export interface TimeRemaining {
  Total: number;
  Days: number;
  Hours: number;
  Minutes: number;
  Seconds: number;
}

export function calculateTimeRemaining(endtime: Date): TimeRemaining {
  const total =
    Date.parse(endtime.toString()) - Date.parse(new Date().toString());
  return {
    Total: total,
    Days: Math.max(0, Math.floor(total / (1000 * 60 * 60 * 24))),
    Hours: Math.max(0, Math.floor((total / (1000 * 60 * 60)) % 24)),
    Minutes: Math.max(0, Math.floor((total / 1000 / 60) % 60)),
    Seconds: Math.max(0, Math.floor((total / 1000) % 60)),
  };
}
